import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import StatusBadge from 'components/StatusBadge';
import Table from 'components/Table';

import { webhooksTable as TEXT } from 'locales/en/webhook';
import { DATE_WITH_HOUR } from 'utils/dateFormat';

import {
  STATUS_PENDING,
  STATUS_COMPLETED,
  STATUS_RUNNING,
  STATUS_FAILED,
  STATUS_SKIPPED,
} from './helpers';

const WebhookTable = ({ data, title, ...rest }) => {
  const getStatus = (item) => {
    if (!!item.completed_at) {
      return STATUS_COMPLETED;
    }

    if (!!item.failed_at) {
      return STATUS_FAILED;
    }

    if (!!item.skipped_at) {
      return STATUS_SKIPPED;
    }

    if (!!item.in_progress_at) {
      return STATUS_RUNNING;
    }

    return STATUS_PENDING;
  };

  return (
    <>
      {title && (
        <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold mb-5">
          {title}
        </h2>
      )}
      <Table
        titles={[
          TEXT.id,
          TEXT.status,
          TEXT.psp,
          TEXT.event,
          TEXT.created_at,
          '',
        ]}
        hasData={!!data.length}
        gridClassName="grid-5-cols"
        {...rest}
      >
        {data.map((item, idx) => {
          const dataIndexNumber = data.length - 1 === idx ? 'last' : idx;

          return (
            <Fragment key={item.id}>
              <Link
                data-index-number={dataIndexNumber}
                className="underline text-javelin-gray-dark text-xs py-3 px-5"
                to={`/webhooks/${item.id}`}
              >
                {item.id}
              </Link>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 pl-5"
              >
                <StatusBadge status={getStatus(item)} className="ml-0" />
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {item.external_id}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {item.event}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
              >
                {format(new Date(item.created_at), DATE_WITH_HOUR)}
              </span>
              <Link
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-light text-xs py-3 px-5 text-right cursor-pointer hover:text-javelin-gray-dark"
                to={`/webhooks/${item.id}`}
              >
                <FontAwesomeIcon
                  icon={['far', 'eye']}
                  className="fill-current my-auto"
                />
              </Link>
            </Fragment>
          );
        })}
      </Table>
    </>
  );
};

WebhookTable.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
};
WebhookTable.defaultProps = {
  data: [],
  title: null,
};
export default WebhookTable;
